export enum SpacePageType {
  Recent = 'Recent',
  Hot = 'Hot',
}

type SpacePageVairant = {
  name: string;
  recentJourney: string;
};

const spacePageVairant: Record<SpacePageType, SpacePageVairant> = {
  [SpacePageType.Recent]: {
    name: 'Recent',
    recentJourney: `/club/journey-recent/recent`,
  },
  [SpacePageType.Hot]: {
    name: 'HOT Spaces',
    recentJourney: `/club/journey-recent/hot`,
  },
};

export const getSpacePageVariant = (spacepageType: SpacePageType) => {
  return spacePageVairant[spacepageType];
};
